import { Col, Row } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import "./RiskAnalysis.css";

export default function Legend() {
  const { t } = useTranslation();

  return (
    <>
      <Row className={"mb-10"}>
        <Col span={12}>
          <Row justify="start">
            <Col>
              <div className={"lowest mr-10"}>1</div>
            </Col>
            <Col span={18}>{t("projectsManagement.riskAnalysis.legend.lowest")}</Col>
          </Row>
        </Col>
        <Col span={12}>
          <Row justify="start">
            <Col>
              <div className={"mediumLow mr-10"}>4</div>
            </Col>
            <Col span={18}>{t("projectsManagement.riskAnalysis.legend.mediumLow")}</Col>
          </Row>
        </Col>
      </Row>
      <Row className={"mb-10"}>
        <Col span={12}>
          <Row justify="start">
            <Col>
              <div className={"veryLow mr-10"}>2</div>
            </Col>
            <Col span={18}>{t("projectsManagement.riskAnalysis.legend.veryLow")}</Col>
          </Row>
        </Col>
        <Col span={12}>
          <Row justify="start">
            <Col>
              <div className={"mediumHigh mr-10"}>6</div>
            </Col>
            <Col span={18}>{t("projectsManagement.riskAnalysis.legend.mediumHigh")}</Col>
          </Row>
        </Col>
      </Row>
      <Row className={"mb-10"}>
        <Col span={12}>
          <Row justify="start">
            <Col>
              <div className={"low mr-10"}>3</div>
            </Col>
            <Col span={18}>{t("projectsManagement.riskAnalysis.legend.low")}</Col>
          </Row>
        </Col>
        <Col span={12}>
          <Row justify="start">
            <Col>
              <div className={"highest mr-10"}>9</div>
            </Col>
            <Col span={18}>{t("projectsManagement.riskAnalysis.legend.highest")}</Col>
          </Row>
        </Col>
      </Row>
    </>
  );
}
